var map = {
	"./Error": "7QZx",
	"./Error.vue": "7QZx",
	"./Lobby": "tCpA",
	"./Lobby.vue": "tCpA",
	"./Play": "IXfl",
	"./Play.vue": "IXfl",
	"./Registration": "0axX",
	"./Registration.vue": "0axX",
	"./Screen": "//2m",
	"./Screen.vue": "//2m",
	"./Slideshow": "QRsu",
	"./Slideshow.vue": "QRsu",
	"./TerminalLogin": "hkOA",
	"./TerminalLogin.vue": "hkOA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "brLu";